var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"81d13768d40b2b25e08d90ccf3513467b6a23d0d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["landing-v2@staderlabs"]={id:"81d13768d40b2b25e08d90ccf3513467b6a23d0d"};
      